/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { PermissionInterface } from "../../interfaces/Permissions.interface";

export interface PermissionState {
	permission: PermissionInterface;
	openModalDeletePermission: boolean;
	formAction: "create" | "edit";
}

const initialState: PermissionState = {
	permission: {
		id: "",
		name: "",
		method: "GET",
		uri: "",
		group: "",
		parent: "",
	},
	openModalDeletePermission: false,
	formAction: "create",
};

export const permissionSlice = createSlice({
	name: "permission",
	initialState,
	reducers: {
		updatePermission: (state, action: PayloadAction<PermissionInterface>) => {
			state.permission = action.payload;
		},
		updateOpenModalDeletePermission: (state, action: PayloadAction<boolean>) => {
			state.openModalDeletePermission = action.payload;
		},
		updateFormAction: (state, action: PayloadAction<"create" | "edit">) => {
			state.formAction = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { updatePermission, updateOpenModalDeletePermission, updateFormAction } = permissionSlice.actions;

export default permissionSlice.reducer;
